import { Controller } from 'stimulus'
import { jsRequest }  from '@react/helpers/fetch'
import { pathname }   from '@react/helpers/fetch'

export default class extends Controller {

  static targets = ['container', 'material']

  fetchExisting() {
    const material = this.hasMaterialTarget ? this.materialTarget.value : ''

    if (!material) {
      this._clear()
      return
    }

    const path   = this.data.get("route")
    const params = { material }
    const format = 'js'
    const url    = pathname({ path, params, format })
    jsRequest(url)
  }

  _clear() {
    if (this.hasContainerTarget) {
      this.containerTarget.innerHTML = ''
    }
  }
}
